import React from "react";
import { useQuery } from "@apollo/client";
import { GET_USER_DETAILS } from "../apis/dashboard-apis/dashboardDetailApi";
import UnauthorizePage from "../components/ErrorPages/UnauthorizePage";

const ProtectedRoute = ({ requireRoles = [], children }) => {
  const { data, loading, error } = useQuery(GET_USER_DETAILS);

  if (loading) return children;
  const userDetails = data?.getAccountDetails?.userDetails;
  if (error || !userDetails) {
    return <UnauthorizePage />;
  }

  const userRoles = Array.isArray(userDetails.roles) ? userDetails.roles : [];
  const userRoleDescriptions = userRoles
    .map((role) => role?.role_description)
    .filter(Boolean);

  if (requireRoles.length > 0) {
    const hasRequiredRole = requireRoles.some((required) =>
      userRoleDescriptions.includes(required)
    );
    if (!hasRequiredRole) {
      return <UnauthorizePage />;
    }
  }

  return children;
};

export default ProtectedRoute;
